// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"trending-down"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.5 7.5L8.50001 12.5L12.5 8.50003L19.25 15.25M14.5 16L20 16V10.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TrendingDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'trending-down',
    ref,
    icon: element,
  },
));

TrendingDownIcon.displayName = 'TrendingDownIcon';

export default TrendingDownIcon;
